import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcPost = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.0187 14.4612C4.90313 13.8127 5.33516 13.1933 5.98369 13.0777L28.9565 8.98355C29.605 8.86797 30.2244 9.30001 30.34 9.94853L33.796 29.3405C33.9116 29.9891 33.4795 30.6085 32.831 30.7241L9.85824 34.8182C9.20971 34.9338 8.59029 34.5018 8.47471 33.8532L5.0187 14.4612Z",
			fill: "#A9AFBB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.05955 21.4378L23.537 28.39C23.6779 28.4533 23.8289 28.4912 23.983 28.5018L31.4673 29.0205C32.1887 29.0704 32.814 28.5262 32.864 27.8048L34.2289 8.10643C34.2789 7.38503 33.7347 6.7597 33.0133 6.70972L9.64605 5.09051C8.92465 5.04052 8.29932 5.58481 8.24933 6.3062L7.28984 20.1529C7.25192 20.7002 7.55915 21.2131 8.05955 21.4378Z",
			fill: "#CED2DA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.29793 20.0897L7.28927 20.183C7.24285 20.6832 7.51615 21.1586 7.97182 21.3702L23.624 28.4162C23.6468 28.4267 23.6698 28.4366 23.6931 28.4456L12.9245 17.0023C12.3273 16.3658 11.3278 16.3325 10.6895 16.9276L7.29793 20.0897Z",
			fill: "#F2F4F8"
		})
	]
});
export default SvgIcPost;
